module.exports = __webpack_public_path__ + "img/Byxor.d248a08a.png";